import TwoFactorAuthActionTypes from './TwoFactorAuthActionTypes';
const resetState = () => ({
  type: 'RESET_STATE'
});
const startVerifying = () => ({
  type: TwoFactorAuthActionTypes.START_VERIFYING
});
const finishVerifying = () => ({
  type: TwoFactorAuthActionTypes.FINISH_VERIFYING
});
const startRequestingCode = () => ({
  type: TwoFactorAuthActionTypes.START_REQUESTING_CODE
});
const finishRequestingCode = () => ({
  type: TwoFactorAuthActionTypes.FINISH_REQUESTING_CODE
});
const startRequestingTwoFactorCall = () => ({
  type: TwoFactorAuthActionTypes.START_REQUESTING_CODE_CALL
});
const finishRequestingTwoFactorCall = () => ({
  type: TwoFactorAuthActionTypes.FINISH_REQUESTING_CODE_CALL
});
const updateTotp = totp => ({
  type: TwoFactorAuthActionTypes.UPDATE_TOTP,
  payload: {
    totp
  }
});
const setTwoFactorMethod = (token, backupCodesEnabled, allowedMethods) => ({
  type: TwoFactorAuthActionTypes.SET_TWO_FACTOR_METHOD,
  payload: {
    token,
    backupCodesEnabled,
    allowedMethods
  }
});
const switchTwoFactorMethod = () => ({
  type: TwoFactorAuthActionTypes.SWITCH_TWO_FACTOR_METHOD,
  payload: {}
});
const setCredentials = credentials => ({
  type: TwoFactorAuthActionTypes.SET_CREDENTIALS,
  payload: {
    credentials
  }
});
const setToken = token => ({
  type: TwoFactorAuthActionTypes.SET_TOKEN,
  payload: Object.assign({}, token)
});
const showTokenExpiredAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_TOKEN_EXPIRED
});
const hideTokenExpiredAlert = () => ({
  type: TwoFactorAuthActionTypes.HIDE_TOKEN_EXPIRED
});
const showNewCodeSentAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_NEW_CODE_SENT
});
const showCodeCallAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_CODE_CALL_ALERT
});
const hideNewCodeSentAlert = () => ({
  type: TwoFactorAuthActionTypes.HIDE_NEW_CODE_SENT
});
const hideCodeCallAlert = () => ({
  type: TwoFactorAuthActionTypes.HIDE_CODE_CALL_ALERT
});
const showInvalidCodeAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_INVALID_CODE
});
const hideInvalidCodeAlert = () => ({
  type: TwoFactorAuthActionTypes.HIDE_INVALID_CODE
});
const showInvalidTokenAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_INVALID_TOKEN
});
const showSmsRateLimitAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_SMS_RATE_LIMIT
});
const showGenericTwoFactorErrorAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_GENERIC_TWO_FACTOR_ERROR
});
const showPasskeyUnsupportedAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_PASSKEY_UNSUPPORTED_ERROR
});
const showBlockedLoginMethodAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_BLOCKED_LOGIN_METHOD_ERROR
});
const showUserDeactivatedAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_USER_DEACTIVATED
});
const showRestrictedIpAddressAlert = () => ({
  type: TwoFactorAuthActionTypes.SHOW_RESTRICTED_IP_ADDRESS
});
const setVettingUrl = vettingUrl => ({
  type: TwoFactorAuthActionTypes.SET_VETTING_URL,
  payload: {
    vettingUrl
  }
});
const hideUserDeactivatedAlert = () => ({
  type: TwoFactorAuthActionTypes.HIDE_USER_DEACTIVATED
});
const toggleRememberDevice = () => ({
  type: TwoFactorAuthActionTypes.TOGGLE_REMEMBER_DEVICE
});
const switchAppState = level => ({
  type: TwoFactorAuthActionTypes.SWITCH_APP_STATE,
  payload: {
    level
  }
});
const setLoginWithHSPrompt = () => ({
  type: TwoFactorAuthActionTypes.LOGIN_WITH_HS_PROMPT
});
const setUsePasskeyFor2FA = usePasskey => ({
  type: TwoFactorAuthActionTypes.SET_USE_PASSKEY_FOR_2FA,
  payload: {
    usePasskey
  }
});
const setPasskeyAaguids = passkeyAaguids => ({
  type: TwoFactorAuthActionTypes.SET_PASSKEY_AAGUIDS,
  payload: {
    passkeyAaguids
  }
});
const setHasPasskeySetup = hasPasskeySetup => ({
  type: TwoFactorAuthActionTypes.SET_HAS_PASSKEY_SETUP,
  payload: {
    hasPasskeySetup
  }
});
export { startVerifying, finishVerifying, startRequestingCode, finishRequestingCode, startRequestingTwoFactorCall, finishRequestingTwoFactorCall, updateTotp, setTwoFactorMethod, switchTwoFactorMethod, setCredentials, showTokenExpiredAlert, hideTokenExpiredAlert, showNewCodeSentAlert, showCodeCallAlert, hideNewCodeSentAlert, hideCodeCallAlert, showInvalidCodeAlert, hideInvalidCodeAlert, showInvalidTokenAlert, showSmsRateLimitAlert, showGenericTwoFactorErrorAlert, showPasskeyUnsupportedAlert, showBlockedLoginMethodAlert, showUserDeactivatedAlert, hideUserDeactivatedAlert, showRestrictedIpAddressAlert, toggleRememberDevice, switchAppState, setLoginWithHSPrompt, setToken, setVettingUrl, resetState, setUsePasskeyFor2FA, setPasskeyAaguids, setHasPasskeySetup };